'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var $$String = require("bs-platform/lib/js/string.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Chunk$Genetics = require("./Chunk.bs.js");

function string_to_effect(param) {
  switch (param) {
    case "*" :
        return /* Stop */1;
    case "M" :
    case "i" :
        return /* Start */0;
    default:
      return /* Nothing */2;
  }
}

function display_codons(input) {
  return $$Array.map((function (x) {
                return $$String.concat("", $$Array.to_list(x));
              }), $$Array.map($$Array.of_list, $$Array.of_list(input)));
}

function make_codons(input) {
  return Chunk$Genetics.chunk_list(3, input);
}

function match_codon(code_type, input, source) {
  return $$Array.fold_left((function (acc, param) {
                var code3 = param.code3;
                if (acc !== undefined) {
                  return acc;
                } else if (Caml_obj.caml_equal(input, param.codon)) {
                  if (code_type !== 3953222) {
                    return Caml_option.some(code3);
                  } else {
                    return Caml_option.some(param.code1);
                  }
                } else {
                  return ;
                }
              }), undefined, source);
}

function match_codons(letter_code, input, source) {
  return List.map((function (x) {
                return match_codon(letter_code, x, source);
              }), Chunk$Genetics.chunk_list(3, input));
}

function display_matches(input) {
  return $$Array.of_list(List.map((function (param) {
                    if (param !== undefined) {
                      return param;
                    } else {
                      return "";
                    }
                  }), input));
}

exports.string_to_effect = string_to_effect;
exports.display_codons = display_codons;
exports.make_codons = make_codons;
exports.match_codon = match_codon;
exports.match_codons = match_codons;
exports.display_matches = display_matches;
/* No side effect */
